import { useField, useFormikContext } from 'formik';
import { useMemo } from 'react';
import GenericTextBox from '../GenericTextBox';

const TextBox = ({
    label,
    css = '',
    autoComplete,
    ...props
}) => {
    const [field, meta] = useField(props);
    const { setFieldValue } = useFormikContext();

    const autoCompleteParams = useMemo(() => {
        if (autoComplete) {
            return {
                ...autoComplete,
                onSelect: (currentValue, value) => {
                    setFieldValue(props.name, `${currentValue}${value}`);

                    if (autoComplete.onSelect) {
                        autoComplete.onSelect(currentValue, value);
                    }
                },
            };
        }

        return null;
    }, [autoComplete, props.name, setFieldValue]);

    const error = useMemo(() => {
        if (meta.touched && meta.error) {
            return <div className='text-danger small'>{meta.error}</div>;
        }

        return null;
    }, [meta]);

    return (
        <div className={`${css}`}>
            <GenericTextBox
                label={label}
                autoComplete={autoCompleteParams}
                css={{
                    input: meta.touched && meta.error ? 'border-danger' : '',
                }}
                {...field}
                {...props}
                defaultValue={field.value}
            />
            {error}
        </div>
    );
};

export default TextBox;